'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestRest = function () {
  function RequestRest($http) {
    (0, _classCallCheck3.default)(this, RequestRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'vendors/requests/',
      STATS: 'vendors/stats/',
      DETAIL: 'vendors/requests/%1$s/',
      CUSTOMERS: 'vendors/requests/customers/',
      CUSTOMER_LEADS: 'vendors/requests/leads/%1$s/',
      DOWNLOAD_REQUEST: 'vendors/requests/export-nonce/',
      DOWNLOAD: 'vendors/requests/export/%1$s/'
    };
  }

  (0, _createClass3.default)(RequestRest, [{
    key: 'stats',
    value: function stats(params) {
      return this.$http.get(this.PATH.STATS, { params: params });
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'getCustomers',
    value: function getCustomers(params) {
      return this.$http.get(this.PATH.CUSTOMERS, { params: params });
    }
  }, {
    key: 'getItem',
    value: function getItem(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'getLeads',
    value: function getLeads(id, params) {
      return this.$http.get(this.sprintf(this.PATH.CUSTOMER_LEADS, id), { params: params });
    }
  }, {
    key: 'downloadRequest',
    value: function downloadRequest() {
      return this.$http.post(this.PATH.DOWNLOAD_REQUEST);
    }
  }, {
    key: 'download',
    value: function download(id, params) {
      var querystring = "";
      for (var k in params) {
        if (querystring !== "") {
          querystring += "&";
        }
        querystring += encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      }
      window.open(this.$http.options.root + "/" + this.sprintf(this.PATH.DOWNLOAD, id) + "?" + querystring, "_blank");
    }
  }]);
  return RequestRest;
}();

exports.default = RequestRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/RequestResource.js
// module id = 321
// module chunks = 0